import { Info } from '@mui/icons-material';
import { Chip } from '@mui/material';
import { CuriosityValue, CuriosityValueProps, CuriosityTranslation } from '@procureai/curiosity-ui-mui';
import { isNil } from 'ramda';

import { TooltipTypography } from '~/components/TooltipTypography/TooltipTypography';

export type CuriosityLinkChipProps = Pick<CuriosityValueProps, 'ns' | 'i18nKey'> & {
  chipVariant?: 'filled' | 'outlined';
};

export const CuriosityLinkChip = ({ ns, i18nKey, chipVariant }: CuriosityLinkChipProps) => {
  return (
    <CuriosityValue ns={ns} i18nKey={i18nKey} valueGetter={(ct) => ct}>
      {(value) => {
        const ct = value as CuriosityTranslation;
        const url = ct.entity.url;

        const iconProps = isNil(url)
          ? undefined
          : {
              deleteIcon: <Info />,
              onDelete: () => {
                window.open(url, '_blank', 'noreferrer');
              },
            };

        return (
          <TooltipTypography title={ct.value}>
            <Chip variant={chipVariant} label={ct.value} {...iconProps} />
          </TooltipTypography>
        );
      }}
    </CuriosityValue>
  );
};
